<template>
    <div class="course-task">
        <van-pull-refresh v-model="refreshing" @refresh="getBusyListEvent(1)">
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :immediate-check="false"
                @load="getBusyListEvent"
                class="live-content"
        >
            <div class="task-li" v-for="(item,index) in list" :key="index" :data-work_busy_id="item.work_busy_id" @click="gotoDetail">

                <div class="task-li-left">{{item.name}}</div>
                <div class="task-li-right">

                    <span class="task-li-txt not" v-if="item.status == 1">未提交</span>
                    <span class="task-li-txt submitted" v-if="item.status == 2">已提交</span>
                    <span class="task-li-txt commented" v-if="item.status == 3">已点评</span>

                    <span class="iconfont icontubiao-"></span>
                </div>
            </div>
        </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import { List,PullRefresh  } from 'vant';
    export default {
        name: "index",
        components:{
            [List.name]:List,
            [PullRefresh .name]:PullRefresh
        },
        data(){
            return {
                work_book_id:'',
                total:0,
                page:1,
                pageSize:14,
                list:[],
                loading: false,
                finished: false,
                refreshing: false,
            }
        },
        mounted() {
            this.util.hideOptionMenu();
            this.work_book_id = this.util.getQueryStr('work_book_id');
            this.getBusyListEvent(1);
        },
        methods:{
            gotoDetail(e){
                var work_busy_id=e.currentTarget.dataset.work_busy_id;

                this.$router.push(this.util.urlPrefix+'/course_task/detail?work_busy_id='+work_busy_id+'&token='+this.util.token);
            },
            getBusyListEvent(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo

                }else{

                    this.page=page

                }
                this.util.server.mini_work.get_busy_list({
                    data:{
                        work_book_id:this.work_book_id,
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    callback: (res => {
                        const { code, data, msg } = res;

                        if(this.refreshing){
                            this.refreshing=false;
                        }
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total = data.total;
                            }
                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.list = data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.list = this.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.loading = false;

                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                    this.loading = false;
                                }
                            }
                        }else{

                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    body{
        background-color: #ffffff;
    }
    .course-task{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .task-li{
        padding: 10px;
        border-bottom: 1px dashed #ccc;
    }
    .task-li-left{
        display: inline-block;
        width: 77%;
        vertical-align: middle;
    }
    .task-li-right{
        vertical-align: middle;
        display: inline-block;
        text-align: right;
        width: 23%;
    }
    .task-li-right .iconfont{
        vertical-align: middle;
    }
    .task-li-right .task-li-txt.not{
        color: #f30;
    }
    .task-li-right .task-li-txt.commented{
        color: #57c78b;
    }
    .task-li-right .task-li-txt.submitted{
        color: #337ab7;
    }
    .no-list{
        text-align: center;
        width: 100%;
        margin-top: 10px;
    }

</style>
